// react-routers components
import { Link } from "react-router-dom";

// prop-types is library for typechecking of props
import PropTypes from "prop-types";

// @mui material components
import Card from "@mui/material/Card";
import Divider from "@mui/material/Divider";
import Tooltip from "@mui/material/Tooltip";
import Icon from "@mui/material/Icon";
import Grid from "@mui/material/Grid";
// Material Dashboard 2 React components
import MDBox from "components/MDBox";
import MDTypography from "components/MDTypography";
import MDAvatar from "components/MDAvatar";
// Material Dashboard 2 React base styles
import colors from "assets/theme/base/colors";
import typography from "assets/theme/base/typography";

// Images
import burceMars from "assets/images/bruce-mars.jpg";
import MDCard from "components/MDCard";
import { Dot } from "UIComponents/Navbars/DashboardNavbar";
import { DashLine } from "UIComponents/Navbars/DashboardNavbar";
import { Avatar } from "@mui/material";
import { useTranslation } from "react-i18next";

function ProfileInfoCard({ title, description, info }) {
  // Render the card info items
  const { text } = colors;
  const { t } = useTranslation();
  const renderItems = (lists) => {
    return lists.map(({ label, value, icon }) => (
      <>
        <DashLine />
        <MDBox display="flex" ml={-0.3} alignItems="center" mt={-0.5}>
          <Dot />

          {icon}

          <MDTypography component="p" ml={1} fontSize="xs" color="text" sx={{ color: text.label }}>
            {label}
          </MDTypography>
          <MDTypography component="p" ml={3}>
            {value}
          </MDTypography>
        </MDBox>
      </>
    ));
  };

  return (
    <MDCard>
      <Grid container>
        <Grid item>
          <Avatar
            variant="square"
            sx={{ borderRadius: "10.5px", width: "64px !important", height: "64px !important" }}
          />
          {renderItems(info)}
        </Grid>
        <Grid item ml={-17}>
          <MDTypography fontSize="sm" sx={{ textAlign: "left" }} fontWeight="bold">
            {title}
          </MDTypography>
          <MDTypography
            color="text"
            fontSize="xs"
            sx={{ textAlign: "left", color: text.desc, mt: 2.5 }}
          >
            {description}
          </MDTypography>
        </Grid>
      </Grid>
    </MDCard>
  );
}

// Setting default props for the ProfileInfoCard
ProfileInfoCard.defaultProps = {
  shadow: true,
};

// Typechecking props for the ProfileInfoCard
ProfileInfoCard.propTypes = {
  title: PropTypes.string.isRequired,
  description: PropTypes.string.isRequired,
  info: PropTypes.objectOf(PropTypes.string).isRequired,
  social: PropTypes.arrayOf(PropTypes.object).isRequired,
  action: PropTypes.shape({
    route: PropTypes.string.isRequired,
    tooltip: PropTypes.string.isRequired,
  }).isRequired,
  shadow: PropTypes.bool,
};

export default ProfileInfoCard;
